export function redactSSN(ssn?: string): string {
  if (!ssn) {
    return 'N/A'
  }

  return `${'*'.repeat(Math.max(ssn.length - 1, 1))}${ssn.slice(-1)}`
}

export function redactPhone(phone?: string): string {
  if (!phone) {
    return 'N/A'
  }

  if (phone.length <= 4) {
    return '*'.repeat(phone.length)
  }

  const visiblePrefix = phone.slice(0, 4)
  const visibleSuffix = phone.slice(-4)
  const maskedLength = Math.max(phone.length - 8, 0)
  return `${visiblePrefix}${'*'.repeat(maskedLength)}${visibleSuffix}`
}

export function redactFullName(firstName?: string, lastName?: string): string {
  if (!firstName || !lastName) {
    return 'N/A'
  }

  return `${firstName[0]}. ${lastName[0]}.`
}

export function formatTimestamp(timestamp: string): string {
  return new Date(timestamp).toLocaleString()
}

export function formatCoordinates(x: number, y: number, z: number): string {
  return `[${x.toFixed(2)}, ${y.toFixed(2)}, ${z.toFixed(2)}]`
}

export function getDroneColor(distanceFromCenter: number): 'green' | 'red' {
  return distanceFromCenter <= 1000 ? 'red' : 'green'
}
